import {
  Attribute,
  Id,
} from '@ess/jg-rule-executor';
import { GetAllAttributes_allAttributes_edges_node } from '@src/app/generated/GetAllAttributes';
import { AttributeInput, AttributeType } from '@src/app/generated/globalTypes';
import { ToJsonInputTranslatable } from '@src/app/model/to-json-input-translatable';

export class PortalAttribute extends Attribute implements ToJsonInputTranslatable {
  constructor(
    id?: Id<Attribute>,
    name?: string,
    attributeType?: AttributeType,
    title?: string
  ) {
    super(
      id,
      name,
      attributeType,
      title
    );
  }

  static fromGql(gql: GetAllAttributes_allAttributes_edges_node): PortalAttribute {
    return new PortalAttribute(
      gql.id,
      gql.name,
      gql.attributeType,
      gql.title
    );
  }

  public toGqlInput(): AttributeInput {
    return {
      attributeType: this.attributeType ?? AttributeType.String,
      name: this.name ?? 'name',
      title: this.title ?? 'title',
    };
  }

  static toJsonInput(attributeInput: AttributeInput): JSON {
    return { attribute: attributeInput } as object as JSON;
  }
}
